import { render, staticRenderFns } from "./NullLanding.vue?vue&type=template&id=6ba3ed52"
import script from "./NullLanding.vue?vue&type=script&lang=js"
export * from "./NullLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports